module.exports = __webpack_public_path__ + "static/media/The-exclusive-gulets.4140176d.jpg";